import { OTAScreen } from './OTA'
import { VersionWallScreen } from './VersionWall'

export const UpdatesScreens = {
  OTA: OTAScreen,
  VersionWall: VersionWallScreen,
}
